// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState } from 'react'
// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import SoftInput from 'components/SoftInput'
import { NumericFormat } from 'react-number-format'
import { useFieldState } from 'hooks/useFieldState'

const CurrencyField = ({
  value,
  label,
  onChange,
  required,
  onBlur = (e) => console.log(e),
  ...rest
}) => {
  const [rawValue, setRawValue] = useState(value)
  const validateCurrency = (value) => {
    return `${value}`.match(/^\$\d{1,3}(,\d{3})*(\.\d{2})?$/)
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    validatorFunction: validateCurrency,
  })
  const handleOnblurWithValidation = (e) => {
    let value = e.target.value
    const isValid = validateCurrency(value)
    handleOnblur?.(value)
    if (isValid) {
      onBlur?.(rawValue)
    }
  }
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="auto"
    >
      <SoftBox ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
        </SoftTypography>
      </SoftBox>
      <NumericFormat
        value={value}
        prefix="$"
        thousandSeparator
        fixedDecimalScale
        decimalScale={2}
        customInput={SoftInput}
        inputProps={{ inputMode: 'numeric' }}
        error={isError}
        success={isSuccess}
        onBlur={handleOnblurWithValidation}
        onValueChange={(values, _sourceInfo) => {
          setRawValue(values.floatValue)
          onChange(values.floatValue)
        }}
        {...rest}
      />
    </SoftBox>
  )
}

// typechecking props for CurrencyField
CurrencyField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default CurrencyField
